import { render, staticRenderFns } from "./TabComponent.vue?vue&type=template&id=fac8c0a8&"
import script from "./TabComponent.vue?vue&type=script&lang=js&"
export * from "./TabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TabComponent.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsSlider } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VImg,
  VTab,
  VTabItem,
  VTabs,
  VTabsSlider,
})
